/* eslint-disable default-case */
import React, { useEffect, useState } from "react";
import { findDonationPageLinkById, getLocationDetails, paymentPageSplitUp } from "../../api";
import { Col, Hidden } from "react-awesome-styled-grid";
import { DescriptionText, SubmitButton, Input, Textarea } from "../../design";
import {
  SpError,
  SpText,
  SpWidgetButton,
  SpAmountWidget,
  SpAmountWidgetItem,
} from '../../widgetDesign';
// import InputEmail from "./InputEmail";
import { useForm, useWatch } from "react-hook-form";
import formatAmount from '../../utils/formatAmount';
// import InputPhone from "./InputPhone";
// import InputFileUpload from "./InputFileUpload"
import PaymentPageSupport from "./PaymentPageSupport";
import CardIconList from "./CardIconList";
import SmallScreenView from "../../components/smallscreen";
import ProductDetails from "./ProductDetails";
import getCountryPhoneCode from '../../utils/getCountryPhoneCode';
import Account from "./Account";
// import InputFixedAmount from "./InputFixedAmount";
// import InputQuantity from "./InputQuantity";
// import InputAdjustableAmount from "./InputAdjustableAmount";
// import InputNumber from "./InputNumber";
// import InputAlpha from "./InputAlpha";
// import InputAlphaNumeric from "./InputAlphaNumeric";
// import InputPromotionCode from "./InputPromotionCode";
// import InputSingleLineText from "./InputSingleLineText";
// import InputLargeText from "./InputLargeText";
// import ComboBox from './ComboBox';
// import InputTip from "./InputTip";
// import Waiver from "./Waiver";
import { h2FontSize, submitFontSize, submitHeight } from "../../utils/reseponsive";
import currencyFormatter from "../../utils/currencyformatter";
// import { AmountDivideByHundred } from "../../../helper";
// import { COUNTRY_PHONE_CODE } from "../../../appconstants";
// import AsYouType from "libphonenumber-js";


type Props = {
  history: {
    push: Function,
  },
}

const DonationPage = (props: Props) => {
  const { match: { params: { id } }, location: { pathname } } = props;
  const [paymentPageLink, setPaymentPageLink] = useState();
  const [paymentPageMeta, setPaymentPageMeta] = useState();
  const [account, setAccount] = useState();
  const [phoneCode, setPhoneCode] = useState();
  const [amount, setAmount] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [gid, setGid] = useState('');
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState(null);
  const [name, setName] = useState(true);
  const [email, setEmail] = useState(true);
  const [phone, setPhone] = useState(true);
  const [address, setAddress] = useState(true);
  const [interval, setInterval] = useState();
  const [notes, setNotes] = useState('');
  const amountRegex = /^\d*\.?\d*$/;
  const [showPromoError, setShowPromoError] = useState(false);
  const [showAmountError, setShowAmountError] = useState(false);
  const [valAmount, setValAmount] = useState(null);
  useEffect(() => {
    getDonationPageMetaById();
    localStorage.removeItem('donationDtails');
  }, [id]);

  const getDonationPageMetaById = async () => {
    if (id) {
      try {
        const value = await findDonationPageLinkById(id);
        if (value) {
          setPaymentPageLink(value);
          setPaymentPageMeta(value?.donationPageMeta);
          setAccount(value?.account);
          if (value?.donationPageMeta?.status !== 'ACTIVE') {
            props.history.push(`${pathname}/error`);
          }
          setPhoneCode(getCountryPhoneCode(value?.account && value?.account?.country && value?.account?.country?.id));
          setGid(value?.gid);
          const data = value?.donationPageMeta?.donationPageIntervals;
          const intervalData = data.filter((item) => item.default === true);
          setInterval(intervalData[0].interval);
        }
      } catch (e) {
        props.history.push(`${pathname}/error`);
      }
    }
  };

  const amountUpdate = (value) => {
    setSelectedAmount(value);
    const amount = parseFloat(value);
    if (Number(amount)) {
      setCustomAmount(parseFloat(amount, 10).toFixed(2));
      setAmount(amount * 100);
      setValAmount(null);
      setShowAmountError(false);
    }
  };

  const updateAmount = (e) => {
    const { value } = e.currentTarget;
    if (amountRegex.test(value) || value === '') {
      setCustomAmount(value);
      setValAmount(value);
      setShowAmountError(false);
    }
  };

  const amountFormat = (e) => {
    const { value } = e.currentTarget;
    const amount = parseFloat(value);
    if (Number(amount)) {
      setCustomAmount(parseFloat(amount, 10).toFixed(2));
      setValAmount(parseFloat(amount, 10).toFixed(2));
      setShowAmountError(false);
      setAmount(amount * 100);
      setSelectedAmount(amount);
    }
  };

  const handleSubmit = () => {
    if(!interval) {
      setShowPromoError(true);
      return false;
    }
    if (valAmount) {
      if (paymentPageMeta?.minAmount > Number(valAmount.replaceAll('.', ''))) {
        setShowAmountError(true);
        return false;
      }
      if (paymentPageMeta?.maxAmount < Number(valAmount.replaceAll('.', ''))) {
        setShowAmountError(true);
        return false;
      }
    }
    
    const donationDtails = {
      donationPageMetaGid: gid,
      amount,
      interval,
      notes,
      shareEmail: email,
      sharePhoneNumber: phone,
      shareAddress: address,
      shareName: name,
    }
    localStorage.setItem('donationDtails', JSON.stringify(donationDtails));
    props.history.push(props.history.location && props.history.location.pathname + '/pay');
  }

  return (
    <div id="payment-page" style={{ backgroundColor: paymentPageMeta?.primaryColor, padding: '2% 3%'}}>
      <Col md={3} sm={8} lg={3} className="mt-md-5 mb-2 p-4 payment-page-right" >
        <SmallScreenView>
          {account && paymentPageMeta?.enableAccountLabel && <Account primaryColor={paymentPageMeta && paymentPageMeta.primaryColor} isPreview={false} isAdaptive={false} name={account.name} logo={account.largeLogo} />}
          {paymentPageMeta && <ProductDetails
            isPreview={false}
            isAdaptive={false}
            primaryColor={paymentPageMeta && paymentPageMeta?.primaryColor}
            content={paymentPageMeta?.content}
            imageUrl={paymentPageMeta?.bannerImageUrl}
            title={paymentPageMeta?.title}
            venueAddress={paymentPageMeta?.venueAddress}
            coordinate={paymentPageMeta?.coordinate}
            ytVideoId={paymentPageMeta?.ytVideoId}
            ytVideoDescription={paymentPageMeta?.ytVideoDescription}
            ytVideoHeading={paymentPageMeta?.ytVideoHeading}
            gid={gid}
            bannerType={paymentPageMeta?.bannerType}
          />}
        </SmallScreenView>
        <div className="pt-3 s">
          <DescriptionText fontSize={h2FontSize(false, false)} color="#474747">{paymentPageMeta?.title ? paymentPageMeta?.title : gid ? 'DONATE AMOUNT' : 'DONATE AMOUNT'}</DescriptionText>
        </div>
          <div className="payment-page-form-elements py-2 pr-2">
            <div className="mt-3">
                  {
                    paymentPageMeta?.donationPageIntervals && paymentPageMeta?.donationPageIntervals.length !== 0 && (
                      <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f2f2f6', padding: '8px', borderRadius: '15px', flexWrap: 'wrap', gap: '8px' }}>
                        {
                          paymentPageMeta?.donationPageIntervals.map((item) => (
                            <SpText
                              key={item?.interval}
                              fontSize="16px"
                              borderRadius={interval === item?.interval ? '13px' : '0px'}
                              padding="4px 14px"
                              backgroundColor={interval === item?.interval ? paymentPageMeta?.primaryColor : 'transparent'}
                              color={interval === item?.interval ? '#fff' : '#000'}
                              onClick={() => {setInterval(item?.interval); setShowPromoError(false)}}
                              style={{
                                cursor: 'pointer',
                                display: 'inline-block',
                                marginBottom: 0,
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {
                                item?.interval === 'ONETIME' && (
                                  <span>One-time</span>
                                )
                              }
                              {
                                item?.interval === 'WEEK' && (
                                  <span>Weekly</span>
                                )
                              }
                              {
                                item?.interval === 'MONTH' && (
                                  <span>Monthly</span>
                                )
                              }
                              {
                                item?.interval === 'YEAR' && (
                                  <span>Yearly</span>
                                )
                              }
                            </SpText>
                          ))
                        }
                      </div>
                    )
                  }
                  {
                    paymentPageMeta?.showCustomAmount && (
                      <div className="mt-4" style={{ textAlign: 'center' }}>
                    <Input
                      style={{
                        height: '48px',
                        borderRadius: '6px 0px 0px 6px',
                        width: '20px',
                        borderRight: '1px solid transparent',
                        paddingLeft: '5px',
                      }}
                      value={paymentPageLink?.account?.currency?.prefix}
                    />
                    <Input
                      style={{
                        height: '48px',
                        borderRadius: '0px 6px 6px 0px',
                        width: '80%',
                        borderLeft: '1px solid transparent',
                      }}
                      placeholder="Enter Amount"
                      onChange={updateAmount}
                      onBlur={amountFormat}
                      value={customAmount}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    /> 
                      </div>
                    )
                  }
                  <div className="mt-4 mb-4">
                <SpAmountWidget className="mt-4" style={{ textAlign: 'center' }}>
                  {
                    paymentPageMeta?.donationPageAmounts.map((item) => (
                      <SpAmountWidgetItem
                        className="mr-3 mb-3"
                        onClick={() => amountUpdate(item?.amount / 100)}
                        style={{
                          cursor: "pointer",
                          border: selectedAmount === item?.amount / 100 ? `1px solid ${paymentPageMeta?.primaryColor}` : 'none',
                        }}
                      >
                        {paymentPageLink?.account?.currency?.prefix} {formatAmount((item?.amount / 100), paymentPageLink?.account?.currency)}
                      </SpAmountWidgetItem>
                    ))
                  }
                </SpAmountWidget>
                    
                  </div>
                  <div>
                    <SpText fontSize="16px" fontWeight="500">
                      Message to organizer
                    </SpText>
                  </div>
                  <div className="mb-4" style={{ textAlign: 'center'}}>
                    <Textarea
                      rows={5}
                      placeholder="Leave message to..."
                      style={{ width: '80%' }}
                      onChange={(e) => setNotes(e.currentTarget.value)}
                    />
                  </div>
                  <div>
                    <SpText fontSize="16px" fontWeight="500">
                      Share your details with this charity
                    </SpText>
                    <div className="payment-page-form-elements py-2 pr-2">
                     <span className="mr-2"><Input type="checkbox" style={{ width: '30px' }} defaultChecked={name} onClick={({ target }) => setName(target.checked)} /> Name</span>
                     <span className="mr-2"><Input type="checkbox" style={{ width: '30px' }} defaultChecked={email} onClick={({ target }) => setEmail(target.checked)} /> Email</span>
                     <span className="mr-2"><Input type="checkbox" style={{ width: '30px' }} defaultChecked={phone} onClick={({ target }) => setPhone(target.checked)} /> Phone</span>
                     <span className="mr-2"><Input type="checkbox" style={{ width: '30px' }} defaultChecked={address} onClick={({ target }) => setAddress(target.checked)} /> Address</span>
                    </div>
                  </div>
                </div>

          </div>
          {
            paymentPageMeta && (
              <div className="pt-4 text-center">
                {
                  showPromoError ? (
                    <p style={{
                      fontSize: '14px',
                      color: '#ff1e1e',
                      fontWeight: '500',
                      marginBottom: '20px',
                    }}>Please selct the payment interval</p>
                  ) : (
                    <></>
                  )
                }
                {
                  showAmountError ? (
                    <p style={{
                      fontSize: '14px',
                      color: '#ff1e1e',
                      fontWeight: '500',
                      marginBottom: '20px',
                    }}>Custom amount should be inbetween {paymentPageLink?.account?.currency?.prefix} {formatAmount((paymentPageMeta?.minAmount / 100), paymentPageLink?.account?.currency)} - {paymentPageLink?.account?.currency?.prefix} {formatAmount((paymentPageMeta?.maxAmount / 100), paymentPageLink?.account?.currency)}</p>
                  ) : (
                    <></>
                  )
                }
                
                {
                  (amount <= 0) ? (
                    <SubmitButton
                      disabled
                      backgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                      hoverBackgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                      style={{ color: '#40A9FF' }}
                      height={submitHeight(42, false)}
                      className="m-0"
                      fontSize={submitFontSize(false)}
                      type="submit"
                    >
                      Donate Now
                    </SubmitButton>
                  ) : (
                    <SubmitButton
                      backgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                      hoverBackgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                      disabled={false}
                      height={submitHeight(42, false, false)}
                      className="m-0"
                      fontSize={submitFontSize(false, false)}
                      type="submit"
                      onClick={() => handleSubmit()}
                    >
                      Donate Now
                    </SubmitButton>
                  )
                }
                <CardIconList  country={currency}/>
              </div>
            )
          }
        <SmallScreenView>
          {paymentPageMeta && account && <PaymentPageSupport
            primaryColor={paymentPageMeta && paymentPageMeta.primaryColor}
            email={paymentPageMeta.contactUsEmail}
            termsAndCondition={paymentPageMeta.termsAndConditions}
            phone={paymentPageMeta.contactUsPhone}
            isPreview={false}
            isAdaptive={false}
            selectedAccount={account && account}
          />}
        </SmallScreenView>
      </Col>
      <Hidden xs sm>
      <Col md={6} className="p-4 bg-white" style={{ boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.1)", borderRadius: "10px", minHeight: "100%", height: "100%", overflow: "hidden auto" }}>
          <div className="p-3 col-12 col-lg-9" style={{ minHeight: "100%" }}>
            {account && paymentPageMeta?.enableAccountLabel && <Account primaryColor={paymentPageMeta && paymentPageMeta.primaryColor} isPreview={false} isAdaptive={false} name={account?.name} logo={account?.largeLogo} />}
            {paymentPageMeta && <ProductDetails
              isPreview={false}
              isAdaptive={false}
              content={paymentPageMeta?.content}
              imageUrl={paymentPageMeta?.bannerImageUrl}
              title={paymentPageMeta?.title}
              primaryColor={paymentPageMeta?.primaryColor}
              venueAddress={paymentPageMeta?.venueAddress}
              coordinate={paymentPageMeta?.coordinate}
              ytVideoId={paymentPageMeta?.ytVideoId}
              ytVideoDescription={paymentPageMeta?.ytVideoDescription}
              ytVideoHeading={paymentPageMeta?.ytVideoHeading}
              bannerType={paymentPageMeta?.bannerType}
            />}
            {paymentPageMeta && <PaymentPageSupport isPreview={false} isAdaptive={false}
              email={paymentPageMeta?.contactUsEmail}
              phone={paymentPageMeta?.contactUsPhone}
              termsAndCondition={paymentPageMeta?.termsAndConditions}
              primaryColor={paymentPageMeta?.primaryColor}
              agregatorName={account?.aggregatorName}
              selectedAccount={account && account}
            />}
          </div>
        </Col>
      </Hidden>
    </div>
  )
};

export default DonationPage;
